import Swiper from "swiper"
import { find, findAll } from "utils/dom"
import axios from "axios"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	const BASE_URL = window.location.origin;

	async function load_dados() {
		return await axios.get(`${BASE_URL}/api/programacao/`).then((response) => {
			const dados = response.data;
			return dados;
		}).catch((error) => {
			console.log(`Oppss! ${error}`);
			return;
		})
	}

	const $dados = {
		dados: load_dados(),
	}


	const $ = {
		slideToConcerto: findAll('[js-slide-to]'),
		diasFechados: find('[js-dias-fechado]'),
	}


	function textMes(mes) {
		switch (mes) {
			case '01':
			case 1:
				return 'Janeiro';
				break;
			case '02':
			case 2:
				return 'Fevereiro';
				break;
			case '03':
			case 3:
				return 'Março';
				break;
			case '04':
			case 4:
				return 'Abril';
				break;
			case '05':
			case 5:
				return 'Maio';
				break;
			case '06':
			case 6:
				return 'Junho';
				break;
			case '07':
			case 7:
				return 'Julho';
				break;
			case '08':
			case 8:
				return 'Agosto';
				break;
			case '09':
			case 9:
				return 'Setembro';
				break;
			case '10':
			case 10:
				return 'Outubro';
				break;
			case '11':
			case 11:
				return 'Novembro';
				break;
			case '12':
			case 12:
				return 'Dezembro';
				break;
		}
		return;
	}

	function textDias(_arrayDatas) {
		let text = '';

		for (let i = 0; i < _arrayDatas.length; i++) {
			//console.log(_arrayDatas[i])

			const data = _arrayDatas[i].split("-")

			if (i != 0) {
				if (i == _arrayDatas.length - 1) {
					text += ` e ${data[2]}`
				} else {
					text += `, ${data[2]}`
				}
			}
			else {
				text += `${data[2]}`
			}
		}



		return text;
	}



	async function diasFechados() {
		const dados = await $dados.dados;
		//console.log("eele")
		//console.log($dados);
		const diasFechados = dados['datas_fechado'];

		const dataHoje = new Date();
		const mesHoje = dataHoje.getMonth() + 1;
		const anoHoje = dataHoje.getFullYear();

		const datasFiltradas = diasFechados.filter((item) => {
			const dataFiltro = new Date(`${item}T${dataHoje.toLocaleTimeString()}`);

			return dataFiltro.getMonth() + 1 == mesHoje && dataFiltro.getFullYear() == anoHoje;
		})

		const datasFiltradasOrdenadas = datasFiltradas.sort((a, b) => new Date(a) - new Date(b));


		if (datasFiltradasOrdenadas && datasFiltradasOrdenadas.length > 0) {
			$.diasFechados.innerText = `Em ${textMes(mesHoje)} estaremos fechados no(s) dia(s) ${textDias(datasFiltradasOrdenadas)}`
		} else {
			$.diasFechados.innerText = `Em ${textMes(mesHoje)} estaremos fechados somente nas Segundas!`;
		}


	}


	const SwiperProgramacao = new Swiper(".swiper-programacao", {
		slidesPerView: 1.2,
		spaceBetween: 20,
		//mousewheel: true,
		navigation: {
			nextEl: ".swiper-programacao .swiper-button-next",
			prevEl: ".swiper-programacao .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-programacao .swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			767: {
				spaceBetween: 24,
				slidesPerView: 3,
				slidesPerGroup: 2,
				pagination: {
					dynamicBullets: false
				}
			}
		}
	})


	const SwiperExposicao = new Swiper(".swiper-exposicoes", {
		slidesPerView: 1.2,
		spaceBetween: 24,
		//mousewheel: true,
		navigation: {
			nextEl: ".swiper-exposicoes .swiper-button-next",
			prevEl: ".swiper-exposicoes .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-exposicoes .swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 3,
				pagination: {
					dynamicBullets: false,
				}
			}
		}
	})


	const SwiperAconteceu = new Swiper(".swiper-aconteceu", {
		slidesPerView: "auto",
		spaceBetween: 64,
		loop: true,
		speed: 3000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false
		},
		loopAdditionalSlides: 5,
	});

	const SwiperNoticias = new Swiper(".swiper-aconteceu-noticias", {
		slidesPerView: 1.2,
		spaceBetween: 16,

		navigation: {
			nextEl: ".swiper-aconteceu-noticias .swiper-button-next",
			prevEl: ".swiper-aconteceu-noticias .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-aconteceu-noticias .swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 2.4,
				pagination: {
					dynamicBullets: false,
				}
			},
			1600: {
				slidesPerView: 3.2,
			}
		}
	})


	const swiperConcertos = new Swiper(".swiper-concerto-modalidade", {
		slidesPerView: 1,
	})


	const SwiperACasa = new Swiper(".swiper-a-casa", {
		slidesPerView: "auto",
		spaceBetween: 14,
		breakpoints: {
			767: {
				spaceBetween: 20,
			},
			1200: {
				spaceBetween: 24,
			}
		}

	})


	function resetSlideToConcerto() {
		$.slideToConcerto?.forEach((item) => {
			item.classList.remove("active");
		})
	}

	$.slideToConcerto?.forEach((item) => {
		item.addEventListener("click", (e) => {
			const id = e.target.getAttribute('js-slide-to');
			swiperConcertos.slideTo(id);
			resetSlideToConcerto()
			e.target.classList.add("active");
		})
	})




	const swiperConcertosItens = new Swiper(".swiper-concerto-item-1", {
		slidesPerView: 1.2,
		spaceBetween: 32,
		navigation: {
			nextEl: ".swiper-concerto-item-1 .swiper-button-next",
			prevEl: ".swiper-concerto-item-1 .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-concerto-item-1 .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 2.6,
			},
			1600: {
				slidesPerView: 3.2,
			}
		}
	})

	const swiperConcertosItens2 = new Swiper(".swiper-concerto-item-2", {
		slidesPerView: 1.2,
		spaceBetween: 32,
		navigation: {
			nextEl: ".swiper-concerto-item-2 .swiper-button-next",
			prevEl: ".swiper-concerto-item-2 .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-concerto-item-2 .swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			767: {
				slidesPerView: 2.6,
			},
			1600: {
				slidesPerView: 3.2,
			}
		}
	})


	diasFechados();




}